import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ThemeProvider, Typography } from '@material-ui/core';

import { useActivation } from '../ActivationContext';
import { useActivationBase } from '../hooks/useActivationBase';
import { usePostAuthRedirectTo } from '../hooks/usePostAuthRedirectTo';
import ChoosePasswordForm from './ChoosePasswordForm';
import {
  ContentContainer, FlexContainer, HeaderBox, Title,
} from './AuthMethodSelection.styles';

import sleepioTheme from '@/themes/sleepioTheme';
import { Footer } from '@/pages/Onboarding/components/Footer/Footer';
import { SleepioHeader } from '@/pages/Onboarding/components/Header/SleepioHeader';
import { useAcceptedLanguage } from '@/hooks/useAcceptedLanguage';
import { buildRedirectParam } from '@/utils/urlHelpers';

/** "Choose a password", reached from the question asked after email verification. */
const ChoosePasswordInner: React.FC = () => {
  useAcceptedLanguage();

  const { t } = useTranslation();
  const history = useHistory();
  const base = useActivationBase();
  const { dispatch } = useActivation();
  // Threaded onward so the app's deep link survives to the final step.
  const redirectParam = buildRedirectParam(usePostAuthRedirectTo());

  useEffect(() => {
    dispatch({ type: 'SET_STEP', step: 'choose_password' });
  }, [dispatch]);

  return (
    <ContentContainer>
      <SleepioHeader />
      <FlexContainer maxWidth="xs">
        <HeaderBox style={{ marginBottom: 24 }}>
          <Title variant="h2" color="textPrimary">
            {t('coverage.pre_onboarding.sleepio.password.choose.title')}
          </Title>
          <Typography color="textPrimary">
            {t('coverage.pre_onboarding.sleepio.password.choose.sub_title')}
          </Typography>
        </HeaderBox>

        <ChoosePasswordForm
          onSaved={() => {
            dispatch({ type: 'SET_STEP', step: 'password_saved' });
            history.push(`${base}/password/saved${redirectParam}`);
          }}
        />
      </FlexContainer>
      <Footer />
    </ContentContainer>
  );
};

export const ChoosePassword: React.FC = () => (
  <ThemeProvider theme={sleepioTheme}>
    <ChoosePasswordInner />
  </ThemeProvider>
);

export default ChoosePassword;
